import { get, writable } from "svelte/store";
import fetch from "/util";

export const menuFavorites = writable([]);

let loadedUserID = null;
let loadPromise = null;

async function readResponse(response) {
    const result = await response.json();
    if (!response.ok) throw new Error(result?.msg || "즐겨찾기를 저장할 수 없습니다.");
    return Array.isArray(result) ? result : [];
}

export async function loadMenuFavorites(userID) {
    if (!userID) {
        loadedUserID = null;
        menuFavorites.set([]);
        return [];
    }
    if (loadedUserID === userID && loadPromise) return loadPromise;

    loadedUserID = userID;
    menuFavorites.set([]);
    loadPromise = fetch("/users/me/menu-favorites")
        .then(readResponse)
        .then((favorites) => {
            menuFavorites.set(favorites);
            return favorites;
        })
        .catch((error) => {
            loadedUserID = null;
            loadPromise = null;
            throw error;
        });
    return loadPromise;
}

async function putMenuFavorites(url, body) {
    const response = await fetch(url, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
    });
    const favorites = await readResponse(response);
    menuFavorites.set(favorites);
    return favorites;
}

// 끌어 옮긴 순서를 먼저 화면에 반영하고, 저장에 실패하면 이전 순서로 되돌린다.
export async function reorderMenuFavorites(paths) {
    const previous = get(menuFavorites);
    menuFavorites.set(paths);
    try {
        return await putMenuFavorites("/users/me/menu-favorites/order", { paths });
    } catch (error) {
        menuFavorites.set(previous);
        throw error;
    }
}

export async function setMenuFavorite(path, selected) {
    return putMenuFavorites("/users/me/menu-favorites", { path, selected });
}
